export default __webpack_public_path__ + "static/media/pokemon_water.6dae24f6.png";